import { Maybe } from 'graphql/jsutils/Maybe'

import { Iso3166Alpha2Enum } from '../lib/graphql'

// Keep it in alphabetical order
const FLAG_ICONS: Record<Iso3166Alpha2Enum, string> = {
  [Iso3166Alpha2Enum.AT]: '🇦🇹',
  [Iso3166Alpha2Enum.BE]: '🇧🇪',
  [Iso3166Alpha2Enum.BG]: '🇧🇬',
  [Iso3166Alpha2Enum.CH]: '🇨🇭',
  [Iso3166Alpha2Enum.CY]: '🇨🇾',
  [Iso3166Alpha2Enum.CZ]: '🇨🇿',
  [Iso3166Alpha2Enum.DE]: '🇩🇪',
  [Iso3166Alpha2Enum.DK]: '🇩🇰',
  [Iso3166Alpha2Enum.EE]: '🇪🇪',
  [Iso3166Alpha2Enum.ES]: '🇪🇸',
  [Iso3166Alpha2Enum.FI]: '🇫🇮',
  [Iso3166Alpha2Enum.FR]: '🇫🇷',
  [Iso3166Alpha2Enum.GB]: '🇬🇧',
  [Iso3166Alpha2Enum.GR]: '🇬🇷',
  [Iso3166Alpha2Enum.HR]: '🇭🇷',
  [Iso3166Alpha2Enum.HU]: '🇭🇺',
  [Iso3166Alpha2Enum.IE]: '🇮🇪',
  [Iso3166Alpha2Enum.IS]: '🇮🇸',
  [Iso3166Alpha2Enum.IT]: '🇮🇹',
  [Iso3166Alpha2Enum.LI]: '🇱🇮',
  [Iso3166Alpha2Enum.LT]: '🇱🇹',
  [Iso3166Alpha2Enum.LU]: '🇱🇺',
  [Iso3166Alpha2Enum.LV]: '🇱🇻',
  [Iso3166Alpha2Enum.MA]: '🇲🇦',
  [Iso3166Alpha2Enum.MC]: '🇲🇨',
  [Iso3166Alpha2Enum.ME]: '🇲🇪',
  [Iso3166Alpha2Enum.MT]: '🇲🇹',
  [Iso3166Alpha2Enum.NL]: '🇳🇱',
  [Iso3166Alpha2Enum.NO]: '🇳🇴',
  [Iso3166Alpha2Enum.PL]: '🇵🇱',
  [Iso3166Alpha2Enum.PT]: '🇵🇹',
  [Iso3166Alpha2Enum.RO]: '🇷🇴',
  [Iso3166Alpha2Enum.SI]: '🇸🇮',
  [Iso3166Alpha2Enum.SK]: '🇸🇰',
  [Iso3166Alpha2Enum.SE]: '🇸🇪',
  [Iso3166Alpha2Enum.TR]: '🇹🇷',
  [Iso3166Alpha2Enum.US]: '🇺🇸',
}

interface GetCountryFlagIconFromCountryIsoCodeProps {
  countryIsoCode: Maybe<Iso3166Alpha2Enum>
}
export const getCountryFlagIconFromCountryIsoCode = ({
  countryIsoCode,
}: GetCountryFlagIconFromCountryIsoCodeProps) => {
  return countryIsoCode
    ? (FLAG_ICONS[countryIsoCode] ?? 'question-mark')
    : 'question-mark'
}
